import React, { useReducer, createContext } from 'react';
import jwtDecode from 'jwt-decode';

const initialState = {
  user: null
};

if (sessionStorage.getItem('jwtToken')) {
  const decodedToken = jwtDecode(sessionStorage.getItem('jwtToken'));


  if (decodedToken.exp * 1000 < Date.now()) {
    sessionStorage.clear();
  } else {
    initialState.user = decodedToken;
  }
}

const AuthContext = createContext({
  user: null,
  login: (userData) => {},
  logout: () => {}
});

function authReducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        user: action.payload
      };
    case 'LOGOUT':
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  function login(userData) {
    if(userData===null){
      sessionStorage.clear();
      dispatch({ type: 'LOGOUT' });
    }else{
      sessionStorage.setItem('jwtToken', userData);

      dispatch({
        type: 'LOGIN',
        payload: userData
      });
    }

  }

  

  function logout() {
    sessionStorage.clear();
    dispatch({ type: 'LOGOUT' });

  }

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };



// WEBPACK FOOTER //
// ./src/context/auth.js